export default __webpack_public_path__ + "static/media/large-arrow-right.68cad32b.svg";